// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Invites {
  margin-top: 30px;
  width: 480px;
  height: 54px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #efeeed;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  cursor: pointer;
  padding: 5px 10px;
}
/* .Invites .number {
  margin-left: 180px;
} */

.usable-container{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.SentInviteHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 14px;
  border-bottom: 1.5px solid #c4c4c4;
  margin-bottom: 8px;
}
.Status p {
  font-weight: 600;
  font-size: 13px;
  color: #373334;
  margin-left: 8px;
}
.invitesSentListEmail {
  font-weight: 400;
  font-size: 14px;
  color: #707070;
  margin-bottom: 3px;
}
.invitesSentListEmail span {
  color: #373334;
  font-weight: 500;
}
.invitesSentListJoiningTime {
  font-weight: 400;
  font-size: 12px;
  color: #707070;
  margin-bottom: 3px;
}
.invitesSentPopupCntainer {
}
.invitesSentPopupContentContainer {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 25px;
  padding: 10px 0px;
  width: 35vw;
}
.inviteSentCloseButtonContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 25px;
  border-bottom: 1px solid;
  border-color: #707070;
  padding-bottom: 10px;
  margin: 10px 0px;
  border-bottom-color: #70707089;
}
.inviteSentCloseButtonContainer h1 {
  font-family: sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #373334;
  margin-bottom: -5px;
}
.inviteSentCloseButtonContainer button {
  border-width: 0px;
  padding: 5px;
  height: 30px;
  width: 30px;
  border-radius: 35px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #f3f2f0;
  cursor: pointer;
  outline: none;
}
.inviteSentCloseIcon {
  color: #373334;
  font-weight: 700;
  font-size: 20px;
}
.inviteSentEmailContainer {
  padding: 0px 25px;
  margin-bottom: 15px;
  width: 100%;
}
.inviteSentEmailContainer p {
  font-weight: 500;
  font-size: 16px;
  color: #373334;
  margin-bottom: 5px;
  margin-left: 25px;
}
.inviteSentEmailContainer input {
  width: 100%;
  border: 1px solid #707070;
  border-radius: 25px;
  padding: 7px 25px;
  color: #707070;
}
.inviteSentMessageTextArea {
  width: 100%;
  border: 1px solid #707070;
  border-radius: 25px;
  padding: 15px 25px;
  color: #707070;
  scrollbar-width: none;
  resize: none;
}
.sentInviteReinvitePopup {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 5px 20px;
}
.sentInviteReinvitePopup p {
  font-weight: 500;
  font-size: 16px;
  color: #373334;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
}
.sentInviteReinvitePopup button {
  border-width: 0px;
  padding: 5px;
  height: 30px;
  width: 30px;
  border-radius: 35px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #f3f2f0;
  cursor: pointer;
}
.inviteSentReinviteButton {
  background-image: linear-gradient(to left, #2677c3, #6d98c1);
  border-radius: 25px;
  padding: 3px 13px;
  align-self: center;
}

.SentInviteJoinedUserMessageInfoContainer {
  padding: 10px 10px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border-radius: 20px;
}
.SentInviteJoinedUserMessageInfoSubject {
  font-weight: 400;
  font-size: 12px;
  color: #707070;
  margin-bottom: 2px;
}
.SentInviteJoinedUserMessageInfoSubjectParagraph {
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  margin-right: 8px;
}

.Invite {
  display: block;
  cursor: pointer;
  color: #4795de;
  text-align: center;
  font-weight: 600;
}
.MessageInfo {
  margin-top: 20px;
  margin-left: 10px;
  font-size: 12px;
}
.MessageInfo span {
  font-weight: 600;
}
@media (max-width: 768px) {
  .Invites {
    width: 370px;
  }
  /* .Invites .number {
    margin: 10px 0px 0px 140px;
  } */
}
@media (max-width: 320px) {
  .Invites {
    width: 100%;
  }
  /* .Invites .number {
    margin: 10px 0px 0px 100px;
  } */
}
.inviteSentListPopupContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 18px;
  cursor: pointer;
}
.post1{
  margin-top: 30px !important;
  scrollbar-width: none !important;
}
.invite-sent-posts-container {
  overflow-y: auto;
  height: 100%; /* or specify a specific height */
  scrollbar-width: thin; /* "thin" for thin scrollbar */
  scrollbar-color: #888 transparent; /* Adjust as needed */
}
.invite-sent-no-posts-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.invite-sent-no-posts-image{
  height: 50vh;
}

.invites-post{
  width: 400px !important;
  /* background-color: #2677c3 !important; */
  margin-right: 15px !important;
}

@media screen and (min-width: 768px) {
  .invites-post{
    width: 350px !important;
    /* background-color: #2677c3 !important; */
    margin-right: 10px !important;
  }
}

@media screen and (min-width: 1024px) {
  .invites-post{
    width: 420px !important;
    /* background-color: #2677c3 !important; */
    margin-right: 15px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Activites/Invites/Invites.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB;2CACyC;EACzC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;AACA;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;EACd;EACA;;KAEG;AACL;AACA;EACE;IACE,WAAW;EACb;EACA;;KAEG;AACL;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,YAAY,EAAE,iCAAiC;EAC/C,qBAAqB,EAAE,8BAA8B;EACrD,iCAAiC,EAAE,qBAAqB;AAC1D;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;IACvB,0CAA0C;IAC1C,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,0CAA0C;IAC1C,6BAA6B;EAC/B;AACF","sourcesContent":[".Invites {\r\n  margin-top: 30px;\r\n  width: 480px;\r\n  height: 54px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #efeeed;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n  border-radius: 50px;\r\n  cursor: pointer;\r\n  padding: 5px 10px;\r\n}\r\n/* .Invites .number {\r\n  margin-left: 180px;\r\n} */\r\n\r\n.usable-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.SentInviteHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  font-size: 14px;\r\n  border-bottom: 1.5px solid #c4c4c4;\r\n  margin-bottom: 8px;\r\n}\r\n.Status p {\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  color: #373334;\r\n  margin-left: 8px;\r\n}\r\n.invitesSentListEmail {\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  color: #707070;\r\n  margin-bottom: 3px;\r\n}\r\n.invitesSentListEmail span {\r\n  color: #373334;\r\n  font-weight: 500;\r\n}\r\n.invitesSentListJoiningTime {\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  color: #707070;\r\n  margin-bottom: 3px;\r\n}\r\n.invitesSentPopupCntainer {\r\n}\r\n.invitesSentPopupContentContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #fff;\r\n  border-radius: 25px;\r\n  padding: 10px 0px;\r\n  width: 35vw;\r\n}\r\n.inviteSentCloseButtonContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0px 25px;\r\n  border-bottom: 1px solid;\r\n  border-color: #707070;\r\n  padding-bottom: 10px;\r\n  margin: 10px 0px;\r\n  border-bottom-color: #70707089;\r\n}\r\n.inviteSentCloseButtonContainer h1 {\r\n  font-family: sans-serif;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  color: #373334;\r\n  margin-bottom: -5px;\r\n}\r\n.inviteSentCloseButtonContainer button {\r\n  border-width: 0px;\r\n  padding: 5px;\r\n  height: 30px;\r\n  width: 30px;\r\n  border-radius: 35px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #f3f2f0;\r\n  cursor: pointer;\r\n  outline: none;\r\n}\r\n.inviteSentCloseIcon {\r\n  color: #373334;\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n}\r\n.inviteSentEmailContainer {\r\n  padding: 0px 25px;\r\n  margin-bottom: 15px;\r\n  width: 100%;\r\n}\r\n.inviteSentEmailContainer p {\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  color: #373334;\r\n  margin-bottom: 5px;\r\n  margin-left: 25px;\r\n}\r\n.inviteSentEmailContainer input {\r\n  width: 100%;\r\n  border: 1px solid #707070;\r\n  border-radius: 25px;\r\n  padding: 7px 25px;\r\n  color: #707070;\r\n}\r\n.inviteSentMessageTextArea {\r\n  width: 100%;\r\n  border: 1px solid #707070;\r\n  border-radius: 25px;\r\n  padding: 15px 25px;\r\n  color: #707070;\r\n  scrollbar-width: none;\r\n  resize: none;\r\n}\r\n.sentInviteReinvitePopup {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: 5px 20px;\r\n}\r\n.sentInviteReinvitePopup p {\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  color: #373334;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n.sentInviteReinvitePopup button {\r\n  border-width: 0px;\r\n  padding: 5px;\r\n  height: 30px;\r\n  width: 30px;\r\n  border-radius: 35px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #f3f2f0;\r\n  cursor: pointer;\r\n}\r\n.inviteSentReinviteButton {\r\n  background-image: linear-gradient(to left, #2677c3, #6d98c1);\r\n  border-radius: 25px;\r\n  padding: 3px 13px;\r\n  align-self: center;\r\n}\r\n\r\n.SentInviteJoinedUserMessageInfoContainer {\r\n  padding: 10px 10px;\r\n  margin-bottom: 10px;\r\n  background-color: #ffffff;\r\n  border-radius: 20px;\r\n}\r\n.SentInviteJoinedUserMessageInfoSubject {\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  color: #707070;\r\n  margin-bottom: 2px;\r\n}\r\n.SentInviteJoinedUserMessageInfoSubjectParagraph {\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  color: #333333;\r\n  margin-right: 8px;\r\n}\r\n\r\n.Invite {\r\n  display: block;\r\n  cursor: pointer;\r\n  color: #4795de;\r\n  text-align: center;\r\n  font-weight: 600;\r\n}\r\n.MessageInfo {\r\n  margin-top: 20px;\r\n  margin-left: 10px;\r\n  font-size: 12px;\r\n}\r\n.MessageInfo span {\r\n  font-weight: 600;\r\n}\r\n@media (max-width: 768px) {\r\n  .Invites {\r\n    width: 370px;\r\n  }\r\n  /* .Invites .number {\r\n    margin: 10px 0px 0px 140px;\r\n  } */\r\n}\r\n@media (max-width: 320px) {\r\n  .Invites {\r\n    width: 100%;\r\n  }\r\n  /* .Invites .number {\r\n    margin: 10px 0px 0px 100px;\r\n  } */\r\n}\r\n.inviteSentListPopupContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 0px;\r\n  margin-bottom: 18px;\r\n  cursor: pointer;\r\n}\r\n.post1{\r\n  margin-top: 30px !important;\r\n  scrollbar-width: none !important;\r\n}\r\n.invite-sent-posts-container {\r\n  overflow-y: auto;\r\n  height: 100%; /* or specify a specific height */\r\n  scrollbar-width: thin; /* \"thin\" for thin scrollbar */\r\n  scrollbar-color: #888 transparent; /* Adjust as needed */\r\n}\r\n.invite-sent-no-posts-container{\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.invite-sent-no-posts-image{\r\n  height: 50vh;\r\n}\r\n\r\n.invites-post{\r\n  width: 400px !important;\r\n  /* background-color: #2677c3 !important; */\r\n  margin-right: 15px !important;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .invites-post{\r\n    width: 350px !important;\r\n    /* background-color: #2677c3 !important; */\r\n    margin-right: 10px !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .invites-post{\r\n    width: 420px !important;\r\n    /* background-color: #2677c3 !important; */\r\n    margin-right: 15px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
